import time from './time'
export default {
  time
}
